// # region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { interval, timeout, timer } from 'rxjs';

// --- HS Code
import { RegistrationCodeValidationResults, RegistrationResultModel } from '../../../models';
import { AppService, EnvService } from '..';
import { OidcService } from '../account/oidc.service';
import { SelfRegistrationBaseService } from './self-registration-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class SelfRegistrationMockService extends SelfRegistrationBaseService {

  constructor(
    private _appService: AppService,
    _envService: EnvService,
    _oidcService: OidcService
  ) {
    super(_envService, _oidcService);
  }

  public override validateRegistrationCode(registrationCode: string): void {
    if (registrationCode.trim().length !== 6) {
      return;
    }

    this._appService.setLoading(true);
    this._registrationCode$.next(registrationCode.trim());

    timer(1000).subscribe(() => {
      if (registrationCode === 'abc123') {
        // success
        this._validationResult$.next({
          validationResult: RegistrationCodeValidationResults.success,
          registrationCode: registrationCode,
          participantId: '1234567890'
        });
      } else if (registrationCode === 'def123') {
        // campign not found
        this._validationResult$.next({
          validationResult: RegistrationCodeValidationResults.campaignNotFound,
          registrationCode: registrationCode,
          participantId: null
        });
      } else if (registrationCode === 'ghi123') {
        // registration code has expired
        this._validationResult$.next({
          validationResult: RegistrationCodeValidationResults.registrationCodeExpired,
          registrationCode: registrationCode,
          participantId: null
        });
      } else if (registrationCode === 'jkl123') {
        // registration code is not yet live
        this._validationResult$.next({
          validationResult: RegistrationCodeValidationResults.campaignNotLive,
          registrationCode: registrationCode,
          participantId: null
        });
      } else if (registrationCode === 'mno123') {
        // Campaign is not a self-registration campaign
        this._validationResult$.next({
          validationResult: RegistrationCodeValidationResults.campaignNotSelfReg,
          registrationCode: registrationCode,
          participantId: null
        });
      } else if (registrationCode === 'pqr123') {
        // user is already a participant on the specified campaign
        this._validationResult$.next({
          validationResult: RegistrationCodeValidationResults.alreadyPaticipating,
          registrationCode: registrationCode,
          participantId: '1234567890'
        });
      }

        this._appService.setLoading(false);
    });
  }

  public override register(registrationCode: string): void {
    this._appService.setLoading(true);

    timer(1000).subscribe(() => {
      this._appService.setLoading(false);

      if (registrationCode === 'abc123') {
        // success
        var model = {
          validationResult: RegistrationCodeValidationResults.success,
          participantId: '3d55e391-4462-45bf-9c1e-95767d78e47f',
          surveyId: '2d4c7a0c-e125-4f02-8e24-3e2645aa6683',
          surveyReference: 'HSC200100'
        } as RegistrationResultModel;
        this._registrationResult$.next(model);
      } else if (registrationCode === 'def123') {
        // campign not found

      } else if (registrationCode === 'ghi123') {
        // registration code has expired
      } else if (registrationCode === 'jkl123') {
        // registration code is not yet live
      } else if (registrationCode === 'mno123') {
        // Campaign is not a self-registration campaign
      } else if (registrationCode === 'pqr123') {
        // user is already a participant on the specified campaign
      }
    });
  }
}
